import React from 'react'
import { invalidatedReasonLabel } from './voucherLabels'
import { TIME_SOURCE, timeSourceTitle } from '../../utils/timeSource'

export interface VoucherOutcomeSource {
  status: string
  expires_at: string | null
  redeemed_at: string | null
  redeemed_order_id: number | null
  redeemed_order_number: string | null
  invalidated_at: string | null
  invalidated_reason: string | null
  invalidated_by: string | null
  invalidation_note: string | null
}

interface Props {
  voucher: VoucherOutcomeSource
  formatDateTime: (iso: string | null) => string | null
}

const VoucherOutcome: React.FC<Props> = ({ voucher, formatDateTime }) => {
  if (voucher.invalidated_at) {
    return (
      <>
        <div title={TIME_SOURCE.app}>Invalidated {formatDateTime(voucher.invalidated_at)}</div>
        <div className='text-muted small'>
          {invalidatedReasonLabel(voucher.invalidated_reason)}
          {voucher.invalidated_by ? ` — ${voucher.invalidated_by}` : ''}
        </div>
        {voucher.invalidation_note && <div className='text-muted small'>{voucher.invalidation_note}</div>}
      </>
    )
  }

  if (voucher.redeemed_at) {
    return (
      <>
        <div title={TIME_SOURCE.app}>Redeemed {formatDateTime(voucher.redeemed_at)}</div>
        {voucher.redeemed_order_number && (
          <div className='text-muted small'>
            on order{' '}
            {voucher.redeemed_order_id
              ? <a href={`/orders/${voucher.redeemed_order_id}`}>{voucher.redeemed_order_number}</a>
              : voucher.redeemed_order_number}
          </div>
        )}
      </>
    )
  }

  if (voucher.status === 'expired') {
    return (
      <div title={timeSourceTitle(voucher.expires_at, TIME_SOURCE.app)}>
        Expired unused{voucher.expires_at ? ` ${formatDateTime(voucher.expires_at)}` : ''}
      </div>
    )
  }

  return <div className='text-muted small'>Not used yet</div>
}

export default VoucherOutcome
